import styled from "styled-components";

export const MainContainer = styled.div`
  padding: 10px 0px 50px 10px;
  display: flex;
  gap: 50px;
  overflow-y: hidden;
  scrollbar-width: none;
  padding-bottom: 2px;
  flex-direction: row;
  position: relative;
  z-index: 9999;
  background-color: #191919;

  .rowsStyle {
    display: flex;
    transition: transform 0.3s ease;
    overflow-x: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;
    gap: 30px;
    margin-right: 16px;
  }

  .cardbox {
    position: relative;
    margin-bottom: 10px;
    box-shadow: 3px 4px 3px rgba(0, 0, 0, 1);
    &:hover .overlay {
      opacity: 1;
    }
  }

  .overlay {
    position: absolute;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0.7),
      rgba(0, 0, 0, 1)
    );
    opacity: 0;
    color: white;
    display: flex;
    flex-direction: column;
    justify-content: end;
    cursor: pointer;
    transition: opacity 0.8s ease;
    padding: 10px;
  }

  /* 🔥 FINAL UPDATED CARD SIZE */
  .imagebox {
    width: 185px;     /* FIXED WIDTH */
    height: 247px;    /* FIXED HEIGHT */
    border-radius: 8px;
    object-fit: cover;
    font-family: "MyCustomFont";
    font-weight: normal;
    transition: transform 0.3s;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 1);
  }

  .imagebox:hover {
    cursor: pointer;
  }

  @media (max-width: 768px) {
    .cardbox {
      box-shadow: none;
    }
    .imagebox {
      width: 90px;
      height: 140px;
      border-radius: 5px;
      box-shadow: none;
    }
    
    .rowsStyle {
      gap: 10px;
    }
    .overlay {
      display: none;
    }
  }
`;

export const HeadingBox = styled.div`
  padding-left: 10px;
  padding-top: 10px;
  margin: 0px;
  color: #ffffff;
  font-size: 22px;
  font-family: "MyCustomFont";
  font-weight: bold;

  @media (max-width: 768px) {
    font-size: 15px;
    padding-bottom: 5px;
    padding-left: 10px;
  }
`;

export const StandardBox = styled.div`
  padding-left: 15px;
  background-color: #191919;
  padding-top: 10px;

  @media (max-width: 768px) {
    padding-left: 0px;
    padding-right: 0px;
  }
`;

export const ButtonLeft = styled.div`
  z-index: 99999;
  color: white;
  position: absolute;
  font-size: 30px;
  padding: 10px;
  cursor: pointer;
  width: 120px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: start;
  background: rgba(0, 0, 0, 0.2);
  border-top-right-radius: 150px;
  border-bottom-right-radius: 150px;

  @media (max-width: 768px) {
    display: none;
  }

  &:hover {
    transform: translate(-2px);
    background: rgba(0, 0, 0, 0.3);
    border-top-right-radius: 150px;
    border-bottom-right-radius: 150px;
  }
`;

export const ButtonRight = styled.div`
  z-index: 9999;
  position: absolute;
  font-size: 30px;
  padding: 10px;
  cursor: pointer;
  margin-left: 90%;
  color: white;
  width: 120px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: end;
  background: rgba(0, 0, 0, 0.2);
  border-top-left-radius: 150px;
  border-bottom-left-radius: 150px;

  @media (max-width: 768px) {
    display: none;
  }

  &:hover {
    transform: translate(2px);
    background: rgba(0, 0, 0, 0.3);
    border-top-left-radius: 150px;
    border-bottom-left-radius: 150px;
  }
`;
